import { createApp } from 'vue'
import VueSanitize from 'vue-3-sanitize'
import store from '@/store'
import globalComponents from '@/components'
import '@/plugins/pwc'
import addAdminClickHandlers from '@/plugins/admin'
import siteLanguage from '@/plugins/siteLanguage'
import axios from '@/plugins/axios'
import datadog from '@/plugins/datadog'
import primeVue from '@/plugins/primeVue'
import vClickOutside from '@/plugins/vClickOutside'
import pendo from '@/plugins/analytics'

function initialiseVue () {
  const mode = window.ecoonline?.env === 'p'
    ? 'production'
    : 'development'

  const app = createApp({
    mode,
    methods: {
      route
    }
  })

  app.use(datadog)
  app.use(globalComponents)
  app.use(store)
  app.use(siteLanguage)
  app.use(axios)
  app.use(VueSanitize)
  app.use(primeVue)
  app.use(vClickOutside)
  app.use(pendo)

  // Legacy click handlers
  addAdminClickHandlers()

  app.config.performance = window.ecoonline?.env !== 'p'
  app.mount('#app')
}

const languagerev = localStorage.getItem('site_languagerev')

if ((typeof (languagerev) === 'undefined') || (languagerev !== window.ecoonline?.languagerev)) {
  fetch(route('ecoonline::texts.json') + '?l=gb')
    .then(response => response.json())
    .then(response => {
      localStorage.setItem('site_texts_gb', JSON.stringify(response.data.site_texts))
    })
  fetch(route('ecoonline::texts.json') + '?l=' + window.ecoonline?.language)
    .then(response => response.json())
    .then(response => {
      localStorage.setItem('site_languagerev', window.ecoonline?.languagerev)
      localStorage.setItem('site_language', response.data.site_language)
      localStorage.setItem('site_texts', JSON.stringify(response.data.site_texts))
      initialiseVue()
    })
} else {
  initialiseVue()
}
